/**
 * Web component that shows a loading spinner when data is loading
 *
 * Example usage:
 *     <boc-loading-indicator></boc-loading-indicator>
 *     <boc-loading-indicator size="60"></boc-loading-indicator>
 */
class BocLoadingIndicator extends HTMLElement {

    /**
     * Creates an instance of BocLoadingIndicator
     */
    constructor() {
        super();
    }

    /**
     * Called when the web component is added to the page
     *
     * The 'size' attribute indicates the width and height of the spinner.
     * E.g. <boc-loading-indicator size="60"></boc-loading-indicator> will make the spinner 60px x 60px
     * @returns {void}
     */
    connectedCallback() {
        this.size = this.hasAttribute('size') ? this.getAttribute('size') : 50;
        this.innerHTML = `<div class="boc-loading-indicator">
            <?xml version="1.0" encoding="utf-8"?>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                style="margin: auto; background: none; display: block; shape-rendering: auto;" width="${this.size}px" height="${this.size}px" 
                viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">    
              <g transform="rotate(0 50 50)">
                <rect x="42.5" y="6.5" rx="7.5" ry="7.5" width="17" fill="#204565" height="17" class="animated-rect" opacity="2"></rect>
              </g>
              <g transform="rotate(40 50 50)">
                <rect x="42.5" y="6.5" rx="7.5" ry="7.5" width="17" height="17" fill="#204565" class="animated-rect" opacity="0.3"></rect>
              </g>
              <g transform="rotate(80 50 50)">
                <rect x="42.5" y="6.5" rx="7.5" ry="7.5" width="17" height="17" fill="#204565" class="animated-rect" opacity="0.4"></rect>
              </g>
              <g transform="rotate(120 50 50)">
                <rect x="42.5" y="6.5" rx="7.5" ry="7.5" width="17" height="17" fill="#204565" class="animated-rect" opacity="0.5"></rect>
              </g>
              <g transform="rotate(160 50 50)">
                <rect x="42.5" y="6.5" rx="7.5" ry="7.5" width="17" height="17" fill="#204565" class="animated-rect" opacity="0.6"></rect>
              </g>
              <g transform="rotate(200 50 50)">
                <rect x="42.5" y="6.5" rx="7.5" ry="7.5" width="17" height="17" fill="#204565" class="animated-rect" opacity="0.7"></rect>
              </g>
              <g transform="rotate(240 50 50)">
                <rect x="42.5" y="6.5" rx="7.5" ry="7.5" width="17" height="17" fill="#204565" class="animated-rect" opacity="0.8"></rect>
              </g>
              <g transform="rotate(280 50 50)">
                <rect x="42.5" y="6.5" rx="7.5" ry="7.5" width="17" height="17" fill="#204565" class="animated-rect" opacity="0.9"></rect>
              </g>
              <g transform="rotate(320 50 50)">
                <rect x="42.5" y="6.5" rx="7.5" ry="7.5" width="17" height="17" fill="#204565" class="animated-rect" opacity="1"></rect>
              </g>
            </svg>
        </div>
        `;
    }
}

// Defines the web component
customElements.define("boc-loading-indicator", BocLoadingIndicator);
